define(["dojo/i18n", "/home/semaphore/scramble4/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"scramble/nls/zh-tw/common"
,"scramble/nls/zh/common"
,"scramble/nls/ja/common"
,"scramble/nls/fr/common"
,"scramble/nls/de/common"
,"scramble/nls/ko/common"
,"scramble/nls/it/common"
,"scramble/nls/ru/common"
,"scramble/nls/nl/common"
,"scramble/nls/cs/common"
,"scramble/nls/tr/common"
,"scramble/nls/pl/common"
,"scramble/nls/fi/common"
,"scramble/nls/hu/common"
,"scramble/nls/sk/common"
,"scramble/nls/en-gb/common"
,"scramble/nls/nb/common"
,"scramble/nls/es/common"
,"scramble/nls/pt/common"
,"scramble/nls/sv/common"
,"/home/semaphore/scramble4/src/scramble/nls/common.js?absMid=scramble/nls/common"
], function(loader, runner) {
   return runner(loader, "scramble/nls/common", __webpack_require__.dj.c(), false);
});